import { render, staticRenderFns } from "./FormCareer.vue?vue&type=template&id=1550b5fe&"
import script from "./FormCareer.vue?vue&type=script&lang=js&"
export * from "./FormCareer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports